import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../../Firebase';

import "../AssignCapsuleModalContent.css";
import userProfilImage from '../../assets/icon_user_profile.svg';


class AssignCapsuleStep1Content extends Component {

    render() {
        return (
            <AssignCapsuleStep1Form {...this.props}/>
        );
    }

}

const style_picture_empty =  {
    filter: "brightness(90%)"
}

const style_selected_user = {
    background: 'rgba(75,153,222,0.25)'
}

const style_disabled_user = {
    background: 'rgba(0,0,0,0.1)'
}


class AssignCapsuleStep1FormBase extends Component {

    render() {
        const {showUsers, currentsUsers, selectedAssignees, alreadyAssigned} = this.props;
        const context = this
    
          return (
              <>

                  <div className="assign-capsule-container">

                      <div className="modal-assignee-header">
                          <div className="modal-assignee-title">Propulser la capsule</div>
                          <img className="modal-assignee-img" src={require('../../../assets/login/astronaut.svg')} alt="Big" />
                      </div>


                      <form onSubmit={this.props.onSubmitSelection}>

                          <div className="modal-assignee-container">

                              <div>
                                  <div className="modal-assignee-form-group">
                                      <input onChange={this.props.onChange} type="modal-poll" className="modal-assignee-question-field container placeholder-label" name="question" placeholder="Rechercher un email ou un nom" />


                                      <div hidden={!(showUsers === true)} className="form-group assignee-selection">
                                          {currentsUsers.map((user) => 
                                          <div key={user.id} id={user.id} 
                                          onClick={alreadyAssigned.includes(user.id) ? null : () => this.props.onSelectAssignee(user)} 
                                          className="assignee" style={alreadyAssigned.includes(user.id) ? style_disabled_user : selectedAssignees[user.id] ? style_selected_user : {}}>
                                              <img
                                                  className="picture-assignee"
                                                  src={user.data().image_url_profile !== null ? user.data().image_url_profile : userProfilImage}
                                                  style={user.data().image_url_profile == null ? style_picture_empty : {}}
                                                  alt='assignee'
                                                  onError={context.props.firebase.profileImgError}
                                              ></img>
                                              <div>
                                                  <div className="assignee-name" key={user.data().firstname} value={user.data().firstname}>{user.data().firstname} {user.data().lastname}</div>
                                                  <div className="assignee-position" key={user.data().position} value={user.data().position}>{user.data().position}</div>
                                              </div>



                                          </div>)}
                                      </div>


                                  </div>

                              </div>
                          </div>
                          <button type="submit" disabled={(Object.keys(selectedAssignees).length === 0)} className="modal-assignee-button">Suivant</button>
                      </form>

                  </div>
              </>
          );
    }

}

const AssignCapsuleStep1Form = withRouter(withFirebase(AssignCapsuleStep1FormBase));


export default AssignCapsuleStep1Content;
export { AssignCapsuleStep1Form};
